"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
exports.default = (0, styles_1.styled)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        overflowY: 'hidden',
        marginLeft: theme.spacing(2),
        width: '100%',
        height: '100%',
        minHeight: '88vh',
        // Todo: review if we really need this. It seems unnecessary
        // '& .ds-scrollbars-view': {
        //   margin: theme.spacing(0, 2),
        //   width: 'auto !important',
        // },
    });
});
